export default {
  marketing: [
    {
      key: 'privacy',
      text: 'Privacy Policy',
      url: '/privacy',
      isCrUrl: true,
      eventTitle: 'Privacy Selected',
    },
    {
      key: 'terms',
      text: 'Terms and Conditions',
      url: '/tos',
      isCrUrl: true,
      eventTitle: 'Terms Selected',
    },
  ],
  corporate: [
    {
      key: 'blog',
      text: 'Crunchyroll Blog',
      url: 'https://www.medium.com/crunchyroll',
      targetBlank: true,
    },
    {
      key: 'privacy',
      text: 'Privacy Policy',
      url: '/privacy',
      isCrUrl: true,
      eventTitle: 'Privacy Selected',
    },
  ],
  genderEqualityUrl: 'https://www.crunchyroll.com/fr/gender-equality-index/',
  sonyDnsUrl:
    'https://privacyportal-cdn.onetrust.com/dsarwebform/d19e506f-1a64-463d-94e4-914dd635817d/b9eb997c-9ede-451b-8fd4-29891782a928.html',
  adChoicesUrl: 'https://www.sonypictures.com/corp/privacy.html#section11B',
  ukMsaUrl:
    'https://www.sonypictures.com/corp/pdfs/modern_slavery_transparency_statement.pdf',
}
